export function formatCurrency(
  value: number | null | undefined,
  locale: string,
  currency: string
) {
  return value != null
    ? new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
      }).format(value)
    : '--';
}

export function formatPercent(
  value: number | null | undefined,
  locale: string
) {
  return value != null
    ? new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value / 100)
    : '--';
}

export function formatPercentFromRatio(
  value: number | null | undefined,
  locale: string
) {
  return value != null
    ? new Intl.NumberFormat(locale, {
        style: 'percent',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value)
    : '--';
}

/** `percentage` in 0–1 form or 0–100 scale */
export function formatPercentFlexible(
  value: number | null | undefined,
  locale: string
) {
  if (value == null) return null;
  const abs = Math.abs(value);
  const asRatio = abs <= 1 ? value : value / 100;
  return new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(asRatio);
}

export function formatIsoDateMedium(dateIso: string, locale: string) {
  const d = new Date(dateIso);
  if (Number.isNaN(d.getTime())) {
    return dateIso;
  }
  return new Intl.DateTimeFormat(locale, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  }).format(d);
}

export function formatNumber(value: number | null | undefined, locale: string) {
  return value != null ? new Intl.NumberFormat(locale).format(value) : '--';
}
